import { PaginationValues } from "../../../types/General/PaginationValues";

export const fetchBreadcrumbsData = async (
  id: string,
  fetchFunction: (
    id: string,
    filterValues?: any,
    paginationValues?: PaginationValues,
  ) => Promise<any>,
  setState: (value: string) => void,
  authRequired: boolean = false,
) => {
  try {
    const auth = authRequired ? sessionStorage.getItem("@sisantoken") : null;
    const data = await fetchFunction(id, auth);
    setState(
      data[0]?.name ||
        data.name ||
        (data.content && data.content[0]?.name) ||
        (data.content && data.content.name) ||
        (data.content && data.content.toString()) ||
        data.toString(),
    );
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
